import { validateDate } from '../../../../shared/lib/validate-date'

export const personalDataValidator = {
    name: {
        required: 'Имя является обязательным полем',
        pattern: {
            value: /^[A-ЯËАZ][A-ЯЁa-яeАZa-z -]+$/,
            message: 'Имя должно начинаться с буквы и содержать только буквы, пробелы и дефис',
        },
    },
    surname: {
        required: 'Фамилия является обязательным полем',
        pattern: {
            value: /^[A-ЯËАZ][A-ЯЁa-яeАZa-z -]+$/,
            message: 'Фамилия должно начинаться с буквы и содержать только буквы, пробелы и дефис',
        },
    },
    patronymic: {
        required: false,
        pattern: {
            value: /^[A-ЯËАZ][A-ЯЁa-яeАZa-z -]+$/,
            message: 'Отчество должно начинаться с буквы и содержать только буквы, пробелы и дефис',
        },
    },
    birthDate: {
        required: 'Дата рождения является обязательным полем',
        validate: validateDate,
    },
    email: {
        required: false,
        pattern: {
            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: 'Напишите в формате abc@mail.ru',
        },
    },
}
